import { prop } from "vue-class-component";

import * as models from "@/models";

export default class EstimatifLinesTableBaseProps {
    categoriesSelected: models.ICategoriesSelection = prop({
        required: true,
    });
}
